import api from "./index";
import { SavedOfferCreate } from "../models/savedOffers";
const BASE = '/saves';

export const createSave = async (saveData: SavedOfferCreate) => {
    try {
        const response = await api.post(`${BASE}/create`, saveData);
        return response.data;
    } catch (error) {
        console.error('Failed to save offer:', error);
        throw error;
    }
};

export const getAllSaves = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getall`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch saved offers:', error);
        throw error;
    }
};

export const deleteSave = async (offer_id: number) => {
    try {
        const response = await api.delete(`${BASE}/delete/${offer_id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to delete saved offer:', error);
        throw error;
    }
};